<script lang="ts">
    
    import { createEventDispatcher } from "svelte";
    import { navigate } from "svelte-navigator";
    import { Icon } from "sveltestrap";

    const dispatch = createEventDispatcher();

    export let href: string = undefined;

    function onClick() {
        if (href) {
            navigate(href);
            return;
        }
        dispatch('click');
    }

</script>

<button class="sidebar-link" on:click={onClick}>
    <div class="icon">
        <slot name="icon">
            <Icon name="link" />
        </slot>
    </div>
    <div class="text">
        <slot>Botón sin texto</slot>
    </div>
</button>

<style lang="scss">

    .sidebar-link {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        width: 100%;
        border: none;
        background-color: transparent;
        color: #fff;
        white-space: nowrap;
        overflow: hidden;

        &:active {
            background-color: rgba(255, 255, 255, 0.1);
        }
    }

    .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        font-size: 1.2rem;
    }

    .text {
        flex: 1 1 0;
        text-align: left;
    }

    :global(.sidebar:not(.open)) {
        .text {
            display: none;
        }
    }

</style>
